<script>
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import { postListPageUserDetail } from '@/api/biz/userDetail'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'PostListTable',
  components: { CustomDictTag },
  mixins: [tableMixin],
  props: {
    userId: undefined
  },
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('标题'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('作者'),
          dataIndex: 'authorName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('类型'),
          dataIndex: 'contentType',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'contentType' }
        },
        {
          title: this.$t('封面图'),
          dataIndex: 'mediaUrls',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'mediaUrls' }
        },
        {
          title: this.$t('频道'),
          dataIndex: 'channelList',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'channelList' }
        },
        {
          title: this.$t('话题'),
          dataIndex: 'topicList',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'topicList' }
        },
        {
          title: this.$t('浏览量'),
          dataIndex: 'viewCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('评论量'),
          dataIndex: 'commentCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('点赞量'),
          dataIndex: 'likeCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('收藏量'),
          dataIndex: 'collectCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('发布时间'),
          dataIndex: 'publishTime',
          scopedSlots: { customRender: 'publishTime' },
          ellipsis: true,
          align: 'center',
          width: '180px'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    userId(newVal) {
      this.getList()
    }
  },
  methods: {
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getList() {
      if (!this.userId) {
        return
      }
      this.loading = true
      this.queryParam.id = this.userId
      postListPageUserDetail(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    }
  }
}
</script>

<template>
  <a-card>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: '160%' }"
    >
      <template slot="contentType" slot-scope="text, record">
        <span v-if="record.contentType === 1">{{ $t('图文') }}</span>
        <span v-else-if="record.contentType === 2">{{ $t('视频') }}</span>
      </template>
      <template slot="channelList" slot-scope="text, record">
        <span v-if="record.channelList && record.channelList.length > 0">{{ record.channelList.join('、') }}</span>
      </template>
      <template slot="topicList" slot-scope="text, record">
        <span v-if="record.topicList && record.topicList.length > 0">{{ record.topicList.join('、') }}</span>
      </template>
      <template slot="mediaUrls" slot-scope="text, record">
        <div style="width:40px;height:40px;">
          <img
            v-if="record.contentType === 1 && record.mediaUrls && record.mediaUrls.length > 0"
            :src="record.mediaUrls[0]"
            style="width:40px;height:40px;"
            @click="handleRecordPreview(record.mediaUrls[0])"
            alt="none"
          />
        </div>
      </template>
      <span slot="publishTime" slot-scope="text, record">
        {{ parseTime(record.publishTime) }}
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-card>
</template>

<style scoped lang="less">

</style>
